







import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import MunicipalityLogo from '@/components/icons/MunicipalityLogo.vue';

@Component({
  components: {
    MunicipalityLogo
  }
})
export default class MunicipalityLogoComponent extends Vue {
  showDefault = false;

  @Prop(String) src!: string;

  @Watch('src')
  changed() {
    this.showDefault = false;
  }

  mounted() {
    this.showDefault = false;
  }
}
